module.exports = __webpack_public_path__ + "assets/Freccia_sinistra.9e057299.svg";